import { render } from "./CatGrupoEmpleadoForm.vue?vue&type=template&id=7ac3c880"
import script from "./CatGrupoEmpleadoForm.vue?vue&type=script&lang=js"
export * from "./CatGrupoEmpleadoForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__